import type { GetContractPageDataResponse } from '@vy/api-definition';
import { GetContractPageDataResponseSchema } from '@vy/api-definition';
import type { QueryClient } from 'react-query';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import type { CustomUseQueryOptions } from '../requests-types/custom-use-query-options';
import { queryKeys } from '../../../services/query-key/query-keys';

export function useContractPage(
  contractId: string,
  options?: CustomUseQueryOptions<GetContractPageDataResponse>,
) {
  const queryKey = queryKeys.contractPage(contractId);
  const queryFunction = getQueryFunction(contractId);

  return useQuery(queryKey, queryFunction, options);
}

export async function prefecthContractPage(contractId: string, queryClient: QueryClient) {
  const queryKey = queryKeys.contractPage(contractId);
  const queryFunction = getQueryFunction(contractId);

  await queryClient.prefetchQuery(queryKey, queryFunction);
}

function getQueryFunction(contractId: string) {
  return () => {
    return getContractPageData(contractId);
  };
}

async function getContractPageData(contractId: string) {
  const api = getPrivateApi();
  const getContractPageDataResponse = await api.getContractPageData({
    contractId,
  });

  return GetContractPageDataResponseSchema.parse(getContractPageDataResponse);
}
